
import { getAction, postAction } from "./http/manage";
const URL = process.env.VUE_APP_API_PREFIX;

// excel数据导入
const excelImport = (params) =>
    postAction(URL + "/subject/excelImport", params);
// 查询科目
const querySubjectList = (params) =>
  getAction(URL + "/subject/querySubjectList", params);
// 创建科目
const createSubject = (params) =>
  postAction(URL + "/subject/createSubject", params);
// 编辑科目
const updateSubject = (params) =>
  postAction(URL + "/subject/updateSubject", params);
// 删除删除信息
const deleteSubject = (params) =>
  postAction(URL + "/subject/deleteSubject?id=" + params.id);

export {
  querySubjectList,
  createSubject,
  updateSubject,
  deleteSubject,
  excelImport
};
